
declare type UnitMap =
    'windunit' |
    'pressureunit' |
    'unit' |
    'feels_like_algo';

export const unitMap = {
    windunit: ['km/h', 'mph', 'ms', 'beaufort', 'knot'],
    pressureunit: ['mbar', 'mercury', 'torr'],
    unit: ['metric', 'US'],
    feels_like_algo: ['Based on Humidex', 'Based on Heat Index'],
};

export function transformUnit(data: number, type: UnitMap) {
    if (unitMap[type]) {
        return unitMap[type][data];
    }
    return 'N/A';
}

